import $ from 'jquery';
import draggable from 'jquery-ui/ui/widgets/draggable.js';
import droppable from 'jquery-ui/ui/widgets/droppable.js';
import { View } from 'backbone';
import template from 'common-views/common-group-config.ejs';
import template_list from 'common-views/common-dialog-list.ejs';
import toolboxItemMapService from 'ToolboxItemMapService';
import listService from 'ListService.js';
import constants from 'Constants.js';
import eventBus         from 'EventBus';

class CommonGroupConfigView extends View {
    initialize(opts) {
        this.options = opts || {};

        this.initLists();

        this.controlsSelected = [];
        this.lastElementSelected = -1;

        this.getDraggableOptions = (parentId)=>{
            const self = this;
            return {
                revert: 'invalid',
                cursor: 'not-allowed',
                scroll: false,
                appendTo: '#common-config-dialog',
                helper: function(event){
                    const movingId = $(event.target).attr('id'),
                        helper = $('<ul class="clone-helper"></ul>');

                    if ( _.includes(self.controlsSelected, movingId) ) {
                        $(`#${parentId} .selected`).clone().each((i, item)=>{
                            helper.append( $(`<li class="ui-sortable-handle"></li>`).append(item) );
                        });    
                    } else {
                        $('.common-group-list .selected').removeClass('selected');
                        self.controlsSelected = [];
                        self.controlsSelected.push(movingId);
                        $(`#${movingId}`).addClass('selected');
                        helper.append( $(`<li class="ui-sortable-handle"></li>`).append($(`#${parentId}`).find(`#${movingId}`).clone()) );
                    }
                    
                    return helper;
                }
            }
        };

        return this;
    }

    initLists() {
        var availableItems = [];
        var commonGroupItems = [];
        const filterFn = item => item.name;

        if (listService.mainKind === 'L' || listService.mainKind === 'R') {
            if (listService.docType === constants.DOC_TYPE_REPORT) {
                availableItems = _.sortBy(toolboxItemMapService.getAvailableReportItems(), filterFn );
                this.model.set('availableItems', availableItems, {silent: true});

                commonGroupItems = _.sortBy(toolboxItemMapService.getReportItemsByGroup('common'), filterFn );
                this.model.set('commonGroupItems', commonGroupItems, {silent: true});
            } else {
                availableItems = _.sortBy(toolboxItemMapService.getAvailableLayoutItems(), filterFn );
                this.model.set('availableItems', availableItems, {silent: true});

                commonGroupItems = _.sortBy(toolboxItemMapService.getLayoutItemsByGroup('common'), filterFn );
                this.model.set('commonGroupItems', commonGroupItems, {silent: true}); 
            }
        } else if (listService.mainKind === 'B') {
            if (listService.docType === constants.DOC_TYPE_REPORT) {
                availableItems = _.sortBy(toolboxItemMapService.getAvailableReportBehaviorItems(), filterFn );
                this.model.set('availableItems', availableItems, {silent: true});

                commonGroupItems = _.sortBy(toolboxItemMapService.getReportBehaviorItemsByGroup('common'), filterFn );
                this.model.set('commonGroupItems', commonGroupItems, {silent: true});
            } else {
                availableItems = _.sortBy(toolboxItemMapService.getAvailableBehaviorItems(), filterFn );
                this.model.set('availableItems', availableItems, {silent: true});

                commonGroupItems = _.sortBy(toolboxItemMapService.getBehaviorItemsByGroup('common'), filterFn );
                this.model.set('commonGroupItems', commonGroupItems, {silent: true});
            }
        }
    }

    moveItems(operation, parentSelector, firstList, secondList) {
        const localThis = this;

        //find selected one
        const items = $(`${parentSelector} li>div.common-list-item.selected`);

        if (items) {
            const sourceList = firstList,
                destinyList = secondList,
                youShallBeSelected = [],
                leftItems = operation === 'add' ? sourceList : destinyList,
                rightItems =  operation === 'add' ? destinyList : sourceList;
            
            _.forEach(items, item=>{
                const itemId = item.id,
                    thisIsTheone = sourceList.splice( sourceList.findIndex(item=>item.factoryKey===itemId), 1 )[0];
                youShallBeSelected.push(thisIsTheone.factoryKey);
                destinyList.splice( destinyList.findIndex(item=>item.name>thisIsTheone.name) , 0, thisIsTheone );
            })

            this.$sourceList.html(template_list({items:leftItems}));
            this.$groupList.html(template_list({items:rightItems}));
            $('#commonSourceControls ul li').draggable(this.getDraggableOptions('commonSourceControls'));
            $('#commonGroupControls ul li').draggable(this.getDraggableOptions('commonGroupControls'));
            
            youShallBeSelected.forEach(item=>$(`#${item}`).addClass('selected'));
        }
    }

    addItem(ev) {
        this.moveItems('add', '#commonSourceControls', this.model.get('availableItems'), this.model.get('commonGroupItems'));
    }

    removeItem(ev) {
        this.moveItems('remove', '#commonGroupControls', this.model.get('commonGroupItems'), this.model.get('availableItems'));
    }

    saveItems() {
        var list = [];
        var items = $('#commonGroupControls li>div.common-list-item');
        if (items && items.length > 0) { 
            _.forEach(items, function(v) {
                var item = { factoryKey: v.id, name: v.innerText.trim(), icon: v.children[0].classList[1] };
                list.push(item);
            });
        }

        if (listService.mainKind === 'L' || listService.mainKind === 'R') {
            if (listService.docType === constants.DOC_TYPE_REPORT) {
                toolboxItemMapService.updateReportCommonGroupItems(list);
            } else {
                toolboxItemMapService.updateCommonGroupItems(list);
            }
        } else if (listService.mainKind === 'B') {
            if (listService.docType === constants.DOC_TYPE_REPORT) {
                toolboxItemMapService.updateReportBehaviorCommonGroupItems(list);
            } else {
                toolboxItemMapService.updateBehaviorCommonGroupItems(list);
            }
        }
    }

    mouseDownHandler(e) {  }

    mouseUpHandler(e) {
        if ( !_.includes(e.target.classList, 'common-list-item')) { return; }

        const controlId = e.target.id,
            listSelected = e.currentTarget.id,
            sourceElements = this.model.get('availableItems'),
            groupElements = this.model.get('commonGroupItems'),
            filterFn = item => item.factoryKey===controlId;

        if (e.ctrlKey || e.metaKey) {
            if ( _.includes(this.controlsSelected, controlId) ) {
                this.controlsSelected.splice( this.controlsSelected.indexOf(controlId), 1 );
            } else {
                this.controlsSelected.push(controlId);
            }
            this.lastElementSelected = listSelected === 'commonSourceControls'
                ? sourceElements.findIndex( filterFn )
                : groupElements.findIndex( filterFn );
        } else if (e.shiftKey) {
            const currentPositionOfElementSelected = listSelected === 'commonSourceControls'
                ? sourceElements.findIndex( filterFn )
                : groupElements.findIndex( filterFn );
            let firstIndex, lastIndex;

            if  (this.lastElementSelected > currentPositionOfElementSelected) {
                firstIndex = currentPositionOfElementSelected;
                lastIndex = this.lastElementSelected;
            } else {
                firstIndex = this.lastElementSelected;
                lastIndex = currentPositionOfElementSelected;
            }

            if (listSelected === 'commonSourceControls') {
                sourceElements.forEach((item,idx)=>{
                    if (idx >= firstIndex && idx <= lastIndex) {
                        this.controlsSelected.push( item.factoryKey );
                    }
                });
                this.controlsSelected = _.uniq(this.controlsSelected);
            } else {
                groupElements.forEach((item,idx)=>{
                    if (idx >= firstIndex && idx <= lastIndex) {
                        this.controlsSelected.push( item.factoryKey );
                    }
                });
                this.controlsSelected = _.uniq(this.controlsSelected);
            }
        } else {
            this.controlsSelected = [];
            this.controlsSelected.push( controlId );

            this.lastElementSelected = listSelected === 'commonSourceControls'
                ? sourceElements.findIndex( filterFn )
                : groupElements.findIndex( filterFn );
        }
        
        $('.common-group-list .selected').removeClass('selected');

        this.controlsSelected.forEach(item=>{
            $(e.currentTarget).find(`#${item}`).addClass('selected');
        })
    }

    moveElements(origin) {
        let srcElements = origin === 'commonSourceControls'
            ? this.model.get('availableItems')
            : this.model.get('commonGroupItems');
        let destElements = origin === 'commonSourceControls'
            ? this.model.get('commonGroupItems')
            : this.model.get('availableItems');
        
        this.controlsSelected.forEach(item=>{
            // remove element:
            let thisIsTheone = srcElements.splice( srcElements.findIndex(item2=>item2.factoryKey === item ), 1)[0];

            // add element:
            destElements.splice( destElements.findIndex(item2=>item2.name>thisIsTheone.name ), 0, thisIsTheone );
        });

        this.model.set({'availableItems': origin === 'commonSourceControls' ? srcElements : destElements}, constants.MODEL_SILENT);
        this.model.set({'commonGroupItems': origin === 'commonSourceControls' ? destElements : srcElements}, constants.MODEL_SILENT);

    }

    markMovedElements(parent) {
        this.controlsSelected.forEach(item=>{
            // We MUST look first for parent container, since id #itemId is not unique in window
            $(parent).find(`#${item}`).addClass('selected');
        })
    }

    render() {
        var self = this;

        this.$el.html( template( _.merge( this.model.toJSON(),{
            commonSourceControlsList: template_list({items:this.model.get('availableItems')}), 
            commonGroupControlsList: template_list({items:this.model.get('commonGroupItems')})
        })));

        $('body').append(this.$el);

        this.$sourceList = $('#commonSourceControls ul');
        this.$groupList = $('#commonGroupControls ul');

        $('#commonSourceControls ul li').draggable(this.getDraggableOptions('commonSourceControls'));
        $('#commonGroupControls ul li').draggable(this.getDraggableOptions('commonGroupControls'));
        
        $('#commonGroupControls').droppable({
            classes: {
                'ui-droppable-hover': 'droppable-hover-new-class'
            },
            tolerance: 'pointer',
            drop: (event, ui)=>{
                if (ui.draggable.closest('div.ui-droppable').attr('id') === 'commonGroupControls') { return; }
                
                this.moveElements('commonSourceControls');
                this.$sourceList.html(template_list({items:this.model.get('availableItems')}));
                this.$groupList.html(template_list({items:this.model.get('commonGroupItems')}));
                $('#commonSourceControls ul li').draggable(this.getDraggableOptions('commonSourceControls'));
                $('#commonGroupControls ul li').draggable(this.getDraggableOptions('commonGroupControls'));

                // mark previous moved elements
                this.markMovedElements('#commonGroupControls');
            },
            over: function(event, ui) {
                if (ui.draggable.closest('div.ui-droppable').attr('id') === 'commonGroupControls') { return; }
                $('body').css('cursor', 'copy');
            },
            out: function(event, ui) {
                $('body').css('cursor', 'not-allowed');
            }
        });

        $('#commonSourceControls').droppable({
            classes: {
                'ui-droppable-hover': 'droppable-hover-new-class'
            },
            tolerance: 'pointer',
            drop: (event, ui)=>{
                if (ui.draggable.closest('div.ui-droppable').attr('id') === 'commonSourceControls') { return; }
                
                this.moveElements('commonGroupControls');
                this.$sourceList.html(template_list({items:this.model.get('availableItems')}));
                this.$groupList.html(template_list({items:this.model.get('commonGroupItems')}));
                $('#commonSourceControls ul li').draggable(this.getDraggableOptions('commonSourceControls'));
                $('#commonGroupControls ul li').draggable(this.getDraggableOptions('commonGroupControls'));
                
                // mark previous moved elements
                this.markMovedElements('#commonSourceControls');
            },
            over: function(event, ui) {
                if (ui.draggable.closest('div.ui-droppable').attr('id') === 'commonSourceControls') { return; }
                $('body').css('cursor', 'copy');
            },
            out: function(event, ui) {
                $('body').css('cursor', 'not-allowed');
            }
        });

        listService.isUndoRedoEnabled = false;

        // Show modal popup window
        const dialog = $( '#common-config-dialog' ).dialog({
            dialogClass: "no-close",
            autoOpen: true,
            height: 'auto',
            width: 540,
            modal: true, 
            resizable: false,
            buttons: [
                {
                    text: 'Save',
                    'class':'btn-addAssetNext btn-std-width',
                    click: function() {
                        self.saveItems();
                        dialog.dialog( "close" );
                        eventBus.trigger('commonGroupUpdated');
                    }
                },
                {
                    text: 'Cancel',
                    'class':'btn-addAssetCancel btn-std-width',
                    click: function() {
                        dialog.dialog( "close" );
                    }
                }
            ],
            close: function() {
                listService.isUndoRedoEnabled = true;
                dialog.dialog("destroy");
                $( '#common-config-dialog').remove();
            }
        });

        $('div[role="dialog"]').draggable({containment: 'body', scroll: false});

        $('#commonSourceControls')
            .on('mouseup', this.mouseUpHandler.bind(self))
            .on('mousedown', this.mouseDownHandler.bind(self));
        
        $('#commonGroupControls')
            .on('mouseup', this.mouseUpHandler.bind(self))
            .on('mousedown', this.mouseDownHandler.bind(self));

        $('#addCommonGroupItem').on('click', function (e) {
            self.addItem(e);
        });

        $('#removeCommonGroupItem').on('click', function (e) {
            self.removeItem(e);
        });

        this.delegateEvents();
        $("#commonGroupControlsList").sortable();

        return this;
    }
}
export default CommonGroupConfigView;